/**
 * Utility function to generate a Id for objects
 * @return {string}
 */
const idGenerator = () => {
    const seed = new Uint8Array(4)
    window.crypto.getRandomValues(seed)
    let id = window.btoa(seed).toString()

    // Remove the = padding from the string
    // https://tools.ietf.org/html/rfc4648#section-3.2 or http://www.faqs.org/rfcs/rfc4648.html
    while(id[id.length - 1] === '=') {
        id = id.substr(0, id.length - 1)
    }

    return id
}

export {idGenerator}
